import { Redirect } from "react-router";
import React from "react";
import { useAuth0 } from "./react-auth0-spa";

const Callback = () => {
  const { isAuthenticated, logout } = useAuth0();
  const signOut = () => logout({ returnTo: window.location.origin });

  let redirectUrl: string | null = window.sessionStorage.getItem("url");

  if (isAuthenticated && redirectUrl) {
    window.sessionStorage.removeItem("url");    
    return <Redirect push to={redirectUrl} />;
  } else {
    signOut();
    return null;
  }  
};

export default Callback;
